/* 授权相关 */
// 不需要跳注册的页面
export const noRegisterPages = [
  // 'user-center',
  "shiyushou-extension",
  "giftbag880",
  "purcotton"
  // 'commonActivity'
];

// 需要授权的页面(授权+注册)
export const authNeedPages = [
  "purcotton",
  "excellent-enjoyment",
  "addition",
  "apply-before",
  "apply",
  "user-center",
  "package-detail",
  "package-org",
  "order-list",
  "order-list-v2",
  "orders",
  "report",
  "coupon",
  "mydmi",
  "dimi",
  "my-policy",
  "pay-details",
  "org-detail-bl",
  "order-detail-v2",
  "order-detail",
  "ccbDiscount",
  "medicalcard-apply",
  "medical-card-give",
  "cardOrderDetail",
  "shiyushou",
  "giftbag880",
  "register-suc",
  "commonActivity",
  "doctor-card-exchange",
  "doctor-card-home",
  "doctor-card-list",
  "doctor-card-apply",
  "doctor-card-member",
  "doctor-card-give",
  "doctor-card-receive",
  "doctorCardCenter",
  // 'assistant',
  "group-buy-detail",
  "add-yuyue",
  "my-account",
  "medical-card",
  "card-transaction-detail",
  "package-58-list"
];
